// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/voice/soundboard/components/SoundboardPlayingToast.module.css';
import SoundboardStore from '@app/features/voice/soundboard/SoundboardStore';
import {observer} from 'mobx-react-lite';

export const SoundboardPlayingToast = observer(() => {
	const active = SoundboardStore.activeToast;
	if (!active) return null;

	return (
		<div className={styles.toastContainer} data-flx="voice.soundboard.playing-toast">
			<span className={styles.emojiBadge}>{active.sound.emoji}</span>
			<div className={styles.toastText}>
				<span className={styles.username}>{active.username}</span>
				<span>played</span>
				<span className={styles.soundName}>{active.sound.name}</span>
			</div>
		</div>
	);
});
